import { getRequest, insertEventsToSearchResults } from "./utils";

const $ = window.jQuery;
const searchResult = $(".search-result");
const searchInput = $(".js-search-input");
const csrfToken = $("meta[name='csrf-token']").attr("content");
const ctrlKey = 17;
const cmdKey = 91;
const vKey = 86;

let ctrlDown = false;
let valueLength = 0;
let isNeedRequest = true;

export default function search() {
	const searchForm = $(".js-search-form");
	const headerSearch = $(".header__search");

	headerSearch.on("click", () => {
		searchForm.toggleClass("active");
	});

	$(document).mouseup(function(e) {
		if (searchForm.has(e.target).length === 0 && e.target !== headerSearch[0]) {
			searchForm.removeClass("active");
		}
	});

	searchInput.on("input", e => {
		const element = $(e.currentTarget);
		const text = searchInput.val();
		if (text.length <= valueLength) {
			isNeedRequest = true;
		}
		element.next().addClass("active");
		if (text.length < 3) {
			searchResult.removeClass("active");
			return;
		}
		if (!isNeedRequest) {
			return;
		}
		getRequest("/search/fast", {
			"_csrf-frontend": csrfToken,
			text,
		}).then(response => {
			const events = response.events;
			searchResult.html("");
			if (!events.length) {
				if (text.length > valueLength) {
					isNeedRequest = false;
				}
				searchResult.text("Результатов нет. Попробуйте сформулировать запрос по-другому.");
			} else {
				valueLength = text.length;
				events.map(event => {
					searchResult.append(insertEventsToSearchResults(event));
					return searchResult;
				});
			}

			searchResult.addClass("active");
		});
	});

	$(".js-search-input").on("blur", e => {
		const element = $(e.currentTarget);
		element.next().removeClass("active");
	});

	$(document).mouseup(e => {
		if (searchResult.has(e.target).length === 0) {
			searchResult.removeClass("active");
		}
	});

	$(document)
		.keydown(e => {
			if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = true;
		})
		.keyup(e => {
			if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = false;
		});

	// Document Ctrl + C/V
	$(document).keydown(e => {
		if (ctrlDown && e.keyCode === vKey) {
			isNeedRequest = true;
			searchInput.trigger("input");
		}
	});
}
